import { createEnv } from '@t3-oss/env-core'
import { z } from 'zod'

export const env = createEnv({
  isServer: false,
  clientPrefix: 'EXPO_PUBLIC_',
  client: {
    EXPO_PUBLIC_SUPABASE_URL: z.string(),
    EXPO_PUBLIC_SUPABASE_PUBLISHABLE_KEY: z.string(),
    EXPO_PUBLIC_DEFAULT_LANGUAGE: z.string(),
    EXPO_PUBLIC_TRAIT_EMBEDDINGS_ENDPOINT: z.string(),
    EXPO_PUBLIC_GOOGLE_API_KEY: z.string(),
    EXPO_PUBLIC_API_URL: z.string(),
    EXPO_PUBLIC_WEB_URL: z.string(),
    EXPO_PUBLIC_API_PATH: z.string(),
    EXPO_PUBLIC_POSTHOG_KEY: z.string(),
    EXPO_PUBLIC_TOLGEE_API_KEY: z.string().optional(),
    EXPO_PUBLIC_TOLGEE_API_URL: z.string().optional(),
    EXPO_PUBLIC_TOLGEE_CDN_URL: z.string(),
    EXPO_PUBLIC_TRANSLATIONS_BUILD_ID: z.string().optional(),
  },
  runtimeEnv: {
    EXPO_PUBLIC_SUPABASE_URL: process.env.EXPO_PUBLIC_SUPABASE_URL,
    EXPO_PUBLIC_SUPABASE_PUBLISHABLE_KEY: process.env.EXPO_PUBLIC_SUPABASE_PUBLISHABLE_KEY,
    EXPO_PUBLIC_DEFAULT_LANGUAGE: 'fi',
    EXPO_PUBLIC_TRAIT_EMBEDDINGS_ENDPOINT: process.env.EXPO_PUBLIC_TRAIT_EMBEDDINGS_ENDPOINT,
    EXPO_PUBLIC_GOOGLE_API_KEY: process.env.EXPO_PUBLIC_GOOGLE_API_KEY,
    EXPO_PUBLIC_WEB_URL: process.env.EXPO_PUBLIC_WEB_URL,
    EXPO_PUBLIC_API_URL: process.env.EXPO_PUBLIC_API_URL,
    EXPO_PUBLIC_POSTHOG_KEY: process.env.EXPO_PUBLIC_POSTHOG_KEY,
    EXPO_PUBLIC_API_PATH: '/api',
    EXPO_PUBLIC_TOLGEE_API_KEY: process.env.EXPO_PUBLIC_TOLGEE_API_KEY,
    EXPO_PUBLIC_TOLGEE_API_URL: process.env.EXPO_PUBLIC_TOLGEE_API_URL,
    EXPO_PUBLIC_TOLGEE_CDN_URL: process.env.EXPO_PUBLIC_TOLGEE_CDN_URL,
    EXPO_PUBLIC_TRANSLATIONS_BUILD_ID: process.env.EXPO_PUBLIC_TRANSLATIONS_BUILD_ID,
  },
  emptyStringAsUndefined: true,
})
